module.exports = __webpack_public_path__ + "img/vino-blanco.1c721058.jpg";